import React, { useState } from "react";
import { toast } from "react-toastify";
import {
  uploadStudentDataViaAdmin,
  uploadFacultyDataViaAdmin,
  uploadSubjectDataViaAdmin, // Add this import
} from "../utils/Api";

const CSVUploader = ({ onUploadSuccess, uploadType = "student" }) => {
  const [uploading, setUploading] = useState(false);

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!file.name.endsWith(".csv")) {
      toast.error("Please upload a CSV file");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    setUploading(true);
    try {
      let response;
      if (uploadType === "faculty") {
        response = await uploadFacultyDataViaAdmin(formData);
      } else if (uploadType === "subject") {
        // Add this condition
        response = await uploadSubjectDataViaAdmin(formData);
      } else {
        response = await uploadStudentDataViaAdmin(formData);
      }

      if (response) {
        toast.success(
          `${response.data.message}. Created: ${response.data.stats.created}, Updated: ${response.data.stats.updated}, Failed: ${response.data.stats.failed}`,
        );
        if (onUploadSuccess) onUploadSuccess();
      } else {
        toast.error("Upload failed");
      }
    } catch (error) {
      toast.error("Error uploading file");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="flex items-center gap-2">
      <input
        type="file"
        accept=".csv"
        onChange={handleFileUpload}
        disabled={uploading}
        className="hidden"
        id="csv-upload"
      />
      <label
        htmlFor="csv-upload"
        className={`cursor-pointer bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded ${
          uploading ? "opacity-50" : ""
        }`}
      >
        {uploading ? "Uploading..." : "Upload CSV"}
      </label>
    </div>
  );
};

export default CSVUploader;
